import { Box, CircularProgress } from '@mui/material'

import { imagePreviewBox } from 'elements/FileUpload/common/styles'
import { concatToSXProp } from 'utils/style'

interface ImagePreviewLoadingProps {
  fullWidth?: boolean
}

export default function ImagePreviewLoading({
  fullWidth = false,
}: ImagePreviewLoadingProps): JSX.Element {
  return (
    <Box
      className="file-upload-file-load"
      aria-hidden
      sx={concatToSXProp(imagePreviewBox, {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.secondary',
        ...(fullWidth && { width: '100%' }),
      })}
    >
      <CircularProgress color="inherit" size={20} />
    </Box>
  )
}
